import { API_URL } from '../constants';

function getImagePath(path: string) {
  return path?.startsWith('uploads') || path?.startsWith('./uploads')
    ? `${API_URL}/${path.replace('./', '').replace('\\', '/')}`
    : path;
}

export { getImagePath };
